import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import Icon from '../../../Icon';
import LogoIcon from '../../../../public/static/images/item/logo.svg';
import ShareIcon from '../../../../public/static/images/item/share.svg';
import {
  setChosenLocationNames,
  setCurrentState,
  setLocationIds,
  switchTab
} from '../../../../actions';
import Bookmark from '../../../Bookmark';
import BackButton from '../../../BackButton';

const HeaderSection = memo(
  ({ isButtonsVisible, isBookmarked, setFavorited }) => {
    const [showShareButton, setShowShareButton] = useState(false);

    const router = useRouter();
    const dispatch = useDispatch();
    const { id } = router.query;

    const onLogoClickHandler = () => {
      dispatch(switchTab(0));
      dispatch(setLocationIds([]));
      dispatch(setChosenLocationNames([]));
      dispatch(setCurrentState(null));

      return router.push('/');
    };

    const onShareClickHandler = async () => {
      try {
        await window.navigator.share({
          url: window.location.href
        });
      } catch (e) {
        if (e.toString().includes('AbortError')) {
          console.log('share operation was aborted');
        }
      }
    };

    useEffect(() => {
      if (window.navigator.share) {
        setShowShareButton(true);
      }
    }, []);

    return (
      <div className="cur-item-header">
        <div className="cur-item-header__left">
          <div className="cur-item-header__left-btn">
            <BackButton />
          </div>
        </div>
        <a
          className="white-header__logo"
          data-cy="white-header-logo"
          onClick={onLogoClickHandler}
          onKeyPress={onLogoClickHandler}
          role="button"
          tabIndex="-1"
        >
          <Icon
            indent={false}
            IconComponent={LogoIcon}
            width={79}
            height={18}
          />
        </a>
        <div className="cur-item-header__right">
          {isButtonsVisible && (
            <>
              <Bookmark
                itemId={id || ''}
                isActive={isBookmarked}
                setFavorited={setFavorited}
                isCurrentItemPage
              />
              {showShareButton && (
                <i
                  role="button"
                  tabIndex={-1}
                  onKeyPress={onShareClickHandler}
                  onClick={onShareClickHandler}
                >
                  <Icon
                    indent={false}
                    IconComponent={ShareIcon}
                    width={13}
                    height={17}
                  />
                </i>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
);

HeaderSection.displayName = `HeaderSection`;

HeaderSection.propTypes = {
  isButtonsVisible: PropTypes.bool,
  isBookmarked: PropTypes.bool,
  setFavorited: PropTypes.func
};

export default HeaderSection;
